<template>
  <div>
    <section class="content">
      

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 graph">
      <div class="box">
        <div class="box-header with-border" id="invoiceChart">
          <h3 class="box-title"></h3>
          <div class="box-body">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p class="text-center">
                <strong>Operaciones por estado</strong>
              </p>
              <canvas id="nicBar" ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="box-body" v-if="!user.isProvider">
      <h4> Proveedores activos </h4>
        <div class="">
          <div style="margin-bottom: 10px">
            <el-row>
              <el-col :span="6">
                <el-input v-model="filters[0].value" placeholder="Buscar"></el-input>
              </el-col>
            </el-row>
          </div>
          <data-tables :data="activeProviders" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filters">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Calificación">
              <template slot-scope="scope">
                <el-rate v-model.number="scope.row.calification" style="float:left;" :disabled="true"></el-rate>
              </template>
            </el-table-column>
            <el-table-column label="Rubros">
                <template slot-scope="scope">
                      <span v-for="(rubro, index) in scope.row.rubros" :key="rubro.idRubro">
                {{rubro.nombre}}
                <span v-if="(index + 1) < scope.row.rubros.length">
                  /
                </span>
                      </span>
                </template>
            </el-table-column>
          </data-tables>
        </div>
    </div>



    <div class="box-body" v-if="!user.isProvider && !userIsPayments">
      <h4> Proveedores mejor calificados </h4>
        <div class="">
          <div style="margin-bottom: 10px">
            <el-row>
              <el-col :span="6">
                <el-input v-model="filtersCalif[0].value" placeholder="Buscar"></el-input>
              </el-col>
            </el-row>
          </div>
          <data-tables :data="calificatedProviders" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filtersCalif">
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Calificación">
              <template slot-scope="scope">
                <el-rate v-model.number="scope.row.calification" style="float:left;" :disabled="true"></el-rate>
              </template>
            </el-table-column>
            <el-table-column label="Rubros">
                <template slot-scope="scope">
                      <span v-for="(rubro, index) in scope.row.rubros" :key="rubro.idRubro">
                {{rubro.nombre}}
                <span v-if="(index + 1) < scope.row.rubros.length">
                  /
                </span>
                      </span>
                </template>
            </el-table-column>
          </data-tables>
        </div>
    </div>



    </section>
  </div>
</template>
<script>
  require('moment')
  // Require needed datatables modules
  import datepicker from 'vue-date-picker'
  import api from '../../api'
  import Chart from 'chart.js'
  import { mapState } from 'vuex'

  export default {
    name: 'Search',
    components: {
      datepicker
    },
    data (router) {
      return {
        generateRandomNumbers (numbers, max, min) {
          var a = []
          for (var i = 0; i < numbers; i++) {
            a.push(Math.floor(Math.random() * (max - min + 1)) + max)
          }
          return a
        },
        titles: [{                      // Columnas que se van a mostrar
          prop: 'companyName',
          label: 'Compañía',
          align: 'center'
        },
        {
          prop: 'cuit',
          label: 'CUIT',
          align: 'center'
        }
        /* {
          prop: 'corporateMail',
          label: 'Mail corporativo',
          align: 'center'
        } */ ],
        filters: [
          {
            prop: ['companyName', 'cuit'],
            value: ''
          }],
        filtersCalif: [
          {
            prop: ['companyName', 'cuit'],
            value: ''
          }],
        section: 'Search',
        loading: '',
        clients: [],
        idUser: this.$store.state.user.idUser,
        table: '',
        showChart: true,
        vue: this,
        providers: [],
        buyOrders: []
      }
    },
    beforeMount () {
      // alert(this.$store.state.countStatus)
      this.getBuyOrders()
      this.getProviders()
      if (!this.$store.state.countStatus) {
        api.request('get', 'api/countStatus?idUser=' + this.idUser)
          .then(response => {
            var data = response.data

            if (data.status) {
              this.$store.commit('SET_COUNTSTATUS', data.status)
              this.status = data.status
            }
          })
          .catch(error => {
            console.log(error)
          })
        api.request('get', 'api/getStatus')
          .then(response => {
            var data = response.data

            if (data.status) {
              this.$store.commit('SET_STATUS', data.status)
              this.statusList = data.status
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      datetime () {
        return new Date()
      },
      isMobile () {
        return (window.innerWidth <= 800 && window.innerHeight <= 600)
      },
      personalNumbers () {
        return this.generateRandomNumbers(12, 1000000, 10000)
      },
      coPilotNumbers () {
        return this.generateRandomNumbers(12, 1000000, 10000)
      },
      activeProviders () {
        return this.providers.filter(el => this.hasProviderActive(el))
      },
      calificatedProviders () {
        return this.providers.sort((a, b) => a.calification < b.calification ? 1 : -1)
      },
      statusList () {
        console.log(this.$store.state.countStatus)
        return this.$store.state.countStatus
      },
      colors () {
        var colors = []
        colors[0] = '#040200'
        colors[1] = '#b9060b'
        colors[2] = '#FF8000'
        colors[3] = '#FFBF00'
        colors[4] = '#4cd6ff'
        colors[5] = '#01DF01'
        colors[6] = '#01DFA5'
        colors[7] = '#0174DF'
        colors[8] = '#0101DF'
        colors[9] = '#A901DB'
        colors[10] = '#DF01A5'
        colors[11] = '#DF013A'
        colors[12] = '#6E6E6E'
        return colors
      },
      datasetOperationsPerMonth () {
        const demo = [[13, 14, 15, 6, 1, 2, 0, 0, 0, 0, 0, 0], [21, 11, 12, 1, 1, 1, 0, 0, 0, 0, 0, 0], [11, 12, 11, 0, 3, 2, 0, 0, 0, 0, 0, 0],
                    [12, 11, 10, 6, 1, 1, 0, 0, 0, 0, 0, 0], [12, 11, 12, 1, 1, 1, 0, 0, 0, 0, 0, 0]]
        var a = []
          // fill: false,
          // borderColor: '#' + this.colors[i],
        for (var i = 0; i < this.statusList.length; i++) {
          a[i] = {
            label: this.statusList[i].description,
            // fill: false,
            // borderColor: '#' + this.colors[i],
            backgroundColor: this.colors[i],
            // data: this.getCountPerMonth(this.statusList[i].statusId)  DEMO
            data: demo[i]
          }
        }
        return a
      },
      labelsChart () {
        var labels = []
        var date = new Date()
        for (var i = 0; i < 12; i++) {
          labels[i] = (i + 1) + '/' + date.getFullYear()
        }
        return labels
      },
      userIsPayments () {
        let isPayment = this.user.roles.find(role => role.rolesId === '2')
        return this.user.isProvider || isPayment !== undefined
      }
    },
    mounted () {
    },
    methods: {
      graphReport () {
        var ctx
        var config
        ctx = document.getElementById('nicBar').getContext('2d')
        config = {
          type: 'bar',
          data: {
            labels: this.labelsChart,
            datasets: this.datasetOperationsPerMonth
          },
          options: {
            responsive: true,
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (value % 1 === 0) { return value } }
                }
              }]
            },
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        new Chart(ctx, config) // eslint-disable-line no-new
      },
      getBuyOrders () {
        if (this.user.isProvider) {
          api.request('GET', 'api/generic/buyOrder?select=fecha_liberacion,statusId,idCompany&condition=idCompany=' + this.user.company.idCompany)
          .then(response => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              let orders = data
              this.buyOrders = orders
              this.graphReport()
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
        } else {
          api.request('GET', 'api/generic/buyOrder?select=fecha_liberacion, statusId')
          .then(response => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              let orders = data
              this.buyOrders = orders
              this.graphReport()
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
        }
      },
      getCountPerMonth (statusId) {
        var buyOrdersMonth = []
        var j = 12
        while (j) {
          buyOrdersMonth[--j] = 0
        }
        var d = new Date()
        var m = d.getMonth()
        var y = d.getFullYear()
        for (var i = 0; i < this.buyOrders.length; i++) {
          var month = Number(this.buyOrders[i].fecha_liberacion.substring(5, 7))
          var year = Number(this.buyOrders[i].fecha_liberacion.substring(0, 4))
          if (this.buyOrders[i].statusId === statusId && ((month <= (m + 1) && year === y))) {
            buyOrdersMonth[month - 1] += 1
          }
        }
        return buyOrdersMonth
      },
      getInvoices () {
        this.invoices = this.$store.state.invoices
      },
      toggleLoading () {
        this.loading = (this.loading === '') ? 'cargando' : ''
      },
      hasProviderActive (provider) {
        return this.$store.state.contacts.some(cont => cont.idCompany === provider.idCompany && cont.idProviderStatus === '2')
      },
      getProviders () {
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/generic/company?select=idCompany,companyName,cuit,calification')
        .then(response => {
          this.providers = response.data
          this.providers.forEach((el, index) => {
            el.calification = parseInt(el.calification)
          })
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
      }
    }
  }
</script>
<style>
  .datetime-picker input {
    height: 4em !important;
  }

  /* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte. */

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.dataTables_length label, .dataTables_filter label{
  margin-bottom: 30px;
  position: static ;
  display:block;
  pointer-events: fill;
  z-index:3000;
}
.statusHover:hover {
  transition: background-color 0.5s ease;
  cursor: pointer;
  background-color:darkgray;
  color:black;
}

</style>



// WEBPACK FOOTER //
// Reports.vue?3e5b194c